import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import appConfig from '../firebase-applet-config.json';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || appConfig.apiKey,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || appConfig.authDomain,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || appConfig.projectId,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || appConfig.storageBucket,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || appConfig.messagingSenderId,
  appId: import.meta.env.VITE_FIREBASE_APP_ID || appConfig.appId
};

const app = initializeApp(firebaseConfig);
export const firestoreDatabaseId = appConfig.firestoreDatabaseId || '(default)';
export const db = getFirestore(app, firestoreDatabaseId);
export const auth = getAuth(app);
export const storage = getStorage(app);

// Production-safe startup diagnostic (no secrets).
console.info(
  `[Chronovela] Firestore database="${firestoreDatabaseId}" project="${firebaseConfig.projectId}"`,
);

// Extended diagnostics when explicitly enabled.
if (import.meta.env.VITE_DEBUG_FIRESTORE === 'true') {
  console.log(`[Firestore Configuration Audit]`);
  console.log(`- Target Firestore Database ID: "${firestoreDatabaseId}"`);
  console.log(`- Target Firebase Project ID: "${firebaseConfig.projectId}"`);
}

auth.onAuthStateChanged((user) => {
  if (import.meta.env.VITE_DEBUG_FIRESTORE === 'true') {
    console.log(`[Firestore Auth Audit] User is: ${user ? `PRESENT (UID: ${user.uid})` : 'ABSENT'}`);
  }
});
